import { Component, OnInit, Input } from '@angular/core';
import { NotificationService, ObservableService, ToastService } from 'src/app/services';
import { Notification } from '../../models';

@Component({
    selector: 'app-notifications-card-item',
    templateUrl: './notifications-card-item.component.html',
    styleUrls: ['./notifications-card-item.component.scss'],
    standalone: false
})
export class NotificationsCardItemComponent implements OnInit {

  @Input() notificationList: Notification[];
  hoverCard: boolean;

  constructor(
    private notificationService: NotificationService,
    private toastService: ToastService,
    private observableService: ObservableService
  ) { }

  ngOnInit() { }

  /**
   * Sets notification as read and plays an observable
   * @param id Notification id
   * @param index Notification index
   */

  async markNotificationAsRead(id: string, index: number) {
    try {
      const res = await this.notificationService.setReadNotification(id);
      if (res.status) {
        this.observableService.updateNotificationData();
        this.notificationList[index].already_read = true;
      }
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }
}
